import React from 'react';
import PropTypes from 'prop-types';

import {
  ExperimentOutlined, HistoryOutlined, MinusCircleOutlined, RocketOutlined, LoadingOutlined,
} from '@ant-design/icons';

// TODO: rename DeploymentStatus?
const PlatformEvent = (props) => {
  const { platformEvent } = props;

  const tagStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '2px 6px',
    gap: 3,
    borderRadius: 6,
    fontSize: 13,
    fontWeight: 400,
  };

  const platformEvents = [
    {
      event: 'loading',
      icon: (
        <LoadingOutlined style={{ fontSize: 12, color: '#fff' }} spin />
      ),
      label: 'Loading',
      style: {
        background: '#062F61',
        color: '#ACDFFA',
        border: '1px solid #0F4987',
      },
    },
    {
      event: 'activated',
      icon: (
        <RocketOutlined />
      ),
      label: 'Deployed',
      style: {
        background: '#062F61',
        color: '#ACDFFA',
        border: '1px solid #0F4987',
      },
    },
    {
      event: 'recovered',
      icon: (
        <HistoryOutlined />
      ),
      label: 'Recovered',
      style: {
        background: '#431418',
        color: '#F37370',
        border: '1px solid #58181C',
      },
    },
    {
      event: 'decommissioned',
      icon: (
        <MinusCircleOutlined />
      ),
      label: 'Decommissioned',
      style: {
        background: '#2C2C2C',
        color: '#AFAFAF',
        border: '1px solid #3A3A3A',
      },
    },
    {
      event: 'testing',
      icon: (
        <ExperimentOutlined />
      ),
      label: 'Testing',
      style: {
        background: '#301C4D',
        color: '#CDA8F0',
        border: '1px solid #3E2069',
      },
    },
  ];

  const event = platformEvents.find((e) => e.event === platformEvent) || platformEvents.find((e) => e.event === 'loading');

  if (event) {
    return (
      <div
        style={{
          ...tagStyle,
          ...event.style,
        }}
      >
        {event.icon}
        <span>
          {event.label}
        </span>
      </div>
    );
  }

  return platformEvent;
};

PlatformEvent.propTypes = {
  platformEvent: PropTypes.string,
};

PlatformEvent.defaultProps = {
  platformEvent: '',
};

export default PlatformEvent;
